import { createFileRoute } from '@tanstack/react-router';
import VerifyEmailPage from 'src/features/plugins/outlook/(auth)/(setup)/verify-email/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup/verify-email')({
  component: VerifyEmailPage,
});
